import React, { useEffect, useState } from "react";
import { useProSidebar } from "react-pro-sidebar";
import { VscBell } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Navbar from "react-bootstrap/Navbar";
import moment from "moment";
import { NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY, fundingClosedText,
  base_url,
  NOTIFICATION_TYPE_PAYMENT_PROCESSED,
  NOTIFICATION_TYPE_LOAN_CLOSED,
  NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED,
  NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED,
  NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED,
  NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED,
  NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED,
  NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED,
  NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE,
  LOAN_CURRENCY_TYPE_USD,
  NOTIFICATION_ENTITY_BUSINESS,
  NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS,
  NOTIFICATION_TYPE_NEW_LOAN_REJECTED,
  NOTIFICATION_TYPE_RENEW_DOCUMENT,
  base_url_socket,
  NOTIFICATION_TYPE_KYC_APPROVED,
  NOTIFICATION_TYPE_KYC_REJECTED,
  COMPLIANCE_APPROVED,
  NOTIFICATION_TYPE_LOAN_DELISTED,
  NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE,
  NOTIFICATION_TYPE_FUNDING_80_PERCENT,
  NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED,
  NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY,
} from "../utilities";
import axios from ".././axios-interceptor";
import { io } from "socket.io-client";
import { FaUserCircle } from "react-icons/fa";
import Cookies from 'js-cookie';
import { clearAllCookies } from "../clearCookies";

// Notification types the business toast below has heading/body text for.
const BUSINESS_TOAST_TYPES = [
  NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY,
  NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE,
  NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED,
  NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED,
  NOTIFICATION_TYPE_FUNDING_80_PERCENT,
  NOTIFICATION_TYPE_KYC_APPROVED,
  NOTIFICATION_TYPE_KYC_REJECTED,
  NOTIFICATION_TYPE_LOAN_CLOSED,
  NOTIFICATION_TYPE_LOAN_DELISTED,
  NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE,
  NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY,
  NOTIFICATION_TYPE_NEW_LOAN_REJECTED,
  NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED,
  NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED,
  NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED,
  NOTIFICATION_TYPE_PAYMENT_PROCESSED,
  NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED,
  NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED,
  NOTIFICATION_TYPE_RENEW_DOCUMENT,
];

const NavBarMain = (props) => {
  let notifCount = props.count;
  const [wish, setWish] = useState("");
  const navigate = useNavigate();
  var today = new Date();
  var curHr = today.getHours();

  const [showNotif, setShowNotif] = useState(false);
  const handleCloseNotif = () => setShowNotif(false);
  // const handleShowNotif = () => setShowNotif(true);
  const [heading, setHeading] = useState("");
  const [msgBody, setMsgBody] = useState("");
  const [notifType, setNotifType] = useState();
  const [notifId, setNotifId] = useState();
  const [notificationData, setNotificationData] = useState([])
  useEffect(() => {
    axios
      .post(base_url + 'notifications/get_business_notifications', {
        user_id: Cookies.get("business_id"),
        notify_to: NOTIFICATION_ENTITY_BUSINESS
      })
      .then((res) => {

        setNotificationData(res.data.data)

      })

  }, [])
  let Count = [];
  notificationData?.forEach(notifi => {
    if (notifi.is_read !== 1) {
      Count.push(notifi)
    }
  })
  let notifLength = Count.length
  useEffect(() => {
    const socket =
      window.location.hostname === "localhost"
        ? io("http://localhost:3051")
        : io(window.location.protocol + "//" + window.location.hostname, {
          path: "/restsocket3051/",
          // autoConnect: false
          // transports: ["websocket"]
        });
    socket.on(NOTIFICATION_ENTITY_BUSINESS, (notification) => {
      let notifi = notification.data;
      if (notifi.user_id === Cookies.get("business_id")) {
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE
        ) {
          setHeading("Congratulations! your loan has been sanctioned");
          setMsgBody(
            `Please refer to the details and accept the loan terms for your money to be received to this ${notifi.reference_number}`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PAYMENT_PROCESSED
        ) {
          setHeading("Congratulations! Your payment has been processed");
          setMsgBody(
            `Your payment has been processed successfully for ${notifi.reference_number}`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_CLOSED
        ) {
          setHeading("Loan closed");
          setMsgBody(
            `Your loan ${notifi.reference_number} has been successfully closed`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED
        ) {
          setHeading("Tenure extension request has been approved");
          setMsgBody(
            `Request for extend tenure has been approved for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_KYC_APPROVED
        ) {
          setHeading("Business KYC form has been approved");
          setMsgBody(
            `KYC has been approved by the admin ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_KYC_REJECTED
        ) {
          setHeading("Business KYC form has been rejected");
          setMsgBody(
            `KYC has been rejected by the admin ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED
        ) {
          setHeading("Tenure extension request has been rejected");
          setMsgBody(
            `Request for extend tenure has been rejected for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED
        ) {
          setHeading("Pre-closure request has been approved");
          setMsgBody(
            `Request for pre-closure has been approved for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED
        ) {
          setHeading("Partial pre-payment request has been approved");
          setMsgBody(
            `Request for partial pre-payment has been approved for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED
        ) {
          setHeading("Pre-closure request has been rejected");
          setMsgBody(
            `Request for pre-closure has been rejected for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED
        ) {
          setHeading("Partial pre-payment request has been rejected");
          setMsgBody(
            `Request for partial pre-payment has been rejected for loan ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_NEW_LOAN_REJECTED
        ) {
          setHeading("New loan request has been rejected");
          setMsgBody(
            `Request for new loan has been rejected for ${notifi.reference_number} `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_LOAN_DELISTED
        ) {
          setHeading("Loan delisted");
          setMsgBody(
            `Loan ${notifi.reference_number} has been delisted `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE
        ) {
          setHeading("Loan technical closure");
          setMsgBody(
            `Loan ${notifi.reference_number} has been technical closed `
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }

        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY
        ) {
          setHeading("Funding closed early");
          setMsgBody(fundingClosedText(notifi));
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY
        ) {
          setHeading("Loan listed for investors");
          setMsgBody(
            `Your loan ${notifi.reference_number} is now open for funding by investors`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_FUNDING_80_PERCENT
        ) {
          setHeading("Loan 80% funded");
          setMsgBody(
            `Your loan ${notifi.reference_number} has reached 80% of its funding target`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED
        ) {
          setHeading("Loan fully funded");
          setMsgBody(
            `Your loan ${notifi.reference_number} has reached its full funding target. Disbursement will follow`
          );
          setNotifType(notifi.notification_type);
          setNotifId(notifi.notification_id);
        }

        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_RENEW_DOCUMENT
        ) {
          if (notifi.status < new Date()) {
            setHeading("KYC document expiry");
            setMsgBody(
              `Renew your ${notifi.reference_number} document which is expired on ${moment(notifi.status).format("DD MMM YYYY")}`
            );
            setNotifType(notifi.notification_type);
            setNotifId(notifi.notification_id);
          } else {
            setHeading("KYC document expiry");
            setMsgBody(
              `Renew your ${notifi.reference_number} document which will expire on ${moment(notifi.status).format("DD MMM YYYY")}`
            );
            setNotifType(notifi.notification_type);
            setNotifId(notifi.notification_id);
          }
        }

        // Only show the toast for a notification this screen has text for (an unmapped type used to
        // open an empty panel with just "View Details" - QA #1).
        if (BUSINESS_TOAST_TYPES.includes(parseInt(notifi.notification_type))) setShowNotif(true);
      }
    });
    // socket.off(NOTIFICATION_ENTITY_BUSINESS)

    if (window.location.pathname === "/businessdashboard") {
      setWish("Hi!")
    }

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleLogout = () => {
    axios.post(base_url + "user/logout", {
      auth_refresh_token: Cookies.get("User_Refreshtoken_Business"),
    });
    // sessionStorage.clear()
    clearAllCookies();
    navigate("/");
  };
  let b_name = props.businessname;

  const handleViewDetails = () => {
    handleCloseNotif();

    axios
      .post(base_url + "notifications/update_is_read_notification", {
        notification_id: notifId,
      })
      .then((res) => {
        switch (parseInt(notifType)) {
          case NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE:
          case NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED:
          case NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED:
          case NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED:
          case NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED:
            if (window.location.pathname === "/myservicerequests") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/myservicerequests");
            }
            break;
          case NOTIFICATION_TYPE_PAYMENT_PROCESSED:
          case NOTIFICATION_TYPE_LOAN_CLOSED:
          case NOTIFICATION_TYPE_NEW_LOAN_REJECTED:
          case NOTIFICATION_TYPE_FUNDING_80_PERCENT:
          case NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED:
          case NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY:
          case NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY:
            if (window.location.pathname === "/myloans") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/myloans");
            }
            break;
          case NOTIFICATION_TYPE_RENEW_DOCUMENT:
            if (window.location.pathname === "/kycdocuments") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/kycdocuments");
            }
            break;
          case NOTIFICATION_TYPE_KYC_APPROVED:
          case NOTIFICATION_TYPE_KYC_REJECTED:
            if (window.location.pathname === "/kycform") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {

              navigate("/kycform");
            }
            break;
          default:
            navigate("/notifications");
            // Handle default case here, if needed
            break;
        }
      });
  };

  return (
    <Navbar className="navbarTop" expand="lg">
      <div className="p-0 nav_first_child">
        {wish != "" ? (
          <Navbar.Brand href="" className="inv_db_navbar_brand ">
            <div className="Inv_Styles">
              {wish != " " ? wish + " " + b_name : " "}
            </div>
            <p>Welcome back, nice to see you again!</p>
          </Navbar.Brand>
        ) : (
          " "
        )}

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            <div className="d-flex">
              {Cookies.get("kyc_status") == COMPLIANCE_APPROVED && <div
                className="bell_styl"
                onClick={() => navigate("/notifications")}
              >
                {notifLength > 0 ? (
                  <img src="./images/bellwith_notif.svg" />
                ) : (
                  <img src="./images/bellwithout.svg" alt="" />
                )}
              </div>}
              <div className="dropdown">
                {Cookies.get("user_id") != "" ? (
                  <div className="d-flex bell align-items-center gap-3">
                    <div>

                      <img
                        className="dropbtn"
                        src="./images/Ben_userProfile.svg"
                        alt="true"
                      />
                    </div>
                  </div>
                ) : (
                  <FaUserCircle className="fs-3 mx-4" />
                )}
                <div className="dropdown-content">
                  {Cookies.get("kyc_status") == COMPLIANCE_APPROVED && <a href="/businessprofile">My Profile</a>}
                  <a onClick={handleLogout} href="">
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </Navbar.Text>
        </Navbar.Collapse>
      </div>

      <Offcanvas
        placement="end"
        show={showNotif}
        onHide={handleCloseNotif}
        {...props}
        className="inv_notif"
      >
        <Offcanvas.Body className="p-3">
          <div>
            <div className="">
              <div>
                <div className="inv_notif_styl">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h3 className="mb-0">{heading}</h3>
                    </div>
                    <img
                      src="./images/Cancel.svg"
                      alt=""
                      className="Cpointer"
                      onClick={handleCloseNotif}
                    />
                  </div>
                  <p className="notif_msg_heigt">{msgBody}</p>
                  <div className="d-flex gap-3 mt-2">
                    <span
                      className="toast_viewdetails"
                      onClick={handleViewDetails}
                    >
                      View Details
                    </span>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Navbar>
  );
};

export default NavBarMain;
